// When the address follows the board: each step along the game replaces the
// `#ply=N` fragment (no fragment at the starting position), so a reload or a
// shared link opens the same position. Pure of React and the DOM.
import { addressPly, fragmentFor, normalHash } from './ply-fragment.ts';

type SyncState = { game?: { id: string }; ply: number; exploring?: { fromPly: number } };

/**
 * The fragment to write for a review state, or undefined to leave the address
 * alone: before the ply the address asked for has been applied (`settled`
 * false, or the opening position would overwrite it), for another game than
 * the screen's, with no game open, or when `hash` already says it. An empty
 * string means: remove the fragment.
 */
export function addressUpdate(state: SyncState, settled: boolean, gameId: string | undefined, hash: string): string | undefined {
  if (!settled || state.game?.id !== gameId) return undefined;
  const at = addressPly(state);
  if (at === undefined) return undefined;
  const want = fragmentFor(at);
  if (want === normalHash(hash)) return undefined;
  return want;
}
